// Default labels
export const CRITICAL_IMPACT = 'Critical Impact';
export const HIGH_IMPACT = 'High Impact';
export const MEDIUM_IMPACT = 'Medium Impact';
export const LOW_IMPACT = 'Low Impact';

export const DEFAULT_LABELS = [
  CRITICAL_IMPACT,
  HIGH_IMPACT,
  MEDIUM_IMPACT,
  LOW_IMPACT,
];

// Maximum length that a label is allowed to be.
export const LABEL_LENGTH_LIMIT = 50;

// Maximum number of labels that can be associated with a given org.
export const LABEL_LIMIT_PER_ORG = 500;

/**
 * Max number of labels per project
 */
export const LABEL_LIMIT_PER_PROJECT = 5;

export type Label = {
  id: number;
  organizationId: number;
  label: string;
}

export type LabelsResponse = {
  labels: Label[];
}

export type ErrorMap = Record<string, Error>;

export type BulkAddLabelResults = {
  errors: ErrorMap;
  created: number;
}
